import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {BehaviorSubject, interval, map, of} from 'rxjs';
import {environment} from "../../environments/environment";
import {catchError, switchMap, tap} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class DegradedModeService {
  private degradedMode$ = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) {}

  init() {
    // premier appel immédiat
    this.http.get<{ degradedMode: boolean }>(environment.apiUrl + "/mode-degrade/status")
      .pipe(
        map(res => res.degradedMode),
        catchError(err => {
          console.error("Erreur récupération mode dégradé", err);
          return of(false);
        })
      )
      .subscribe(mode => this.degradedMode$.next(mode));

    // ensuite, toutes les 10 minutes
    interval(10 * 60 * 1000)
      .pipe(
        switchMap(() =>
          this.http.get<{ degradedMode: boolean }>(environment.apiUrl + "/mode-degrade/status").pipe(
            map(res => res.degradedMode),
            catchError(err => {
              console.error("Erreur récupération mode dégradé", err);
              return of(false);
            })
          )
        )
      )
      .subscribe(mode => this.degradedMode$.next(mode));
  }

  isDegradedMode() {
    return this.degradedMode$.asObservable();
  }
}
